import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { CustomGridCell } from 'components';
import { formatMoney } from 'functions';

export default function CurrencyCell(props: GridCustomCellProps) {
    const { field, dataItem } = props;
    const key = field as keyof typeof dataItem;
    const amount = dataItem[key];

    return (
        <CustomGridCell {...props}>
            <span className={'positive'}>
                {formatMoney(amount)}
            </span>
        </CustomGridCell>
    );
}